import React from 'react';
import {ActivityLogPanel} from './ActivityLogPanel';

export const ActivityLogPage = () => {
  const documentTitle = 'Activity Log - Detexian';
  document.title = documentTitle;

  return <ActivityLogPanel timeFilterDefault={'month'}/>
};
